// extracted by mini-css-extract-plugin
export default {"pageWrapper":"ScanPrinterBarcodePage_pageWrapper__w3tqy","title":"ScanPrinterBarcodePage_title__tNHuY"};